module.exports = __webpack_public_path__ + "static/how-to-b210fb72469f71c81c32dd410f3a559a.png";